// extracted by mini-css-extract-plugin
export default {"message-text":"Q5yDq","message-text_side_main":"RUSnV","message-text_side_opposite":"gWlLW","message-text__text":"nRseA"};